package org.bsvac.bsvac_kmp.data.models

enum class AmbulanceUnitModel(val displayString: String) {
    BSVAC_2("BSVAC-2"),
    BSVAC_3("BSVAC-3"),
    BSVAC_4("BSVAC-4"),
    BSVAC_5("BSVAC-5"),
    BSVAC_6("BSVAC-6"),
    BSVAC_7("BSVAC-7"),
    GVEMS_7("GVEMS 7"),
    GVEMS_8("GVEMS 8"),
    GVEMS_9("GVEMS 9"), ;

    companion object {
        fun validEntries(selectedAgency: AgencyModel?): List<AmbulanceUnitModel> {
            return when(selectedAgency) {
                AgencyModel.BSVAC -> listOf(
                    BSVAC_2,
                    BSVAC_3,
                    BSVAC_4,
                    BSVAC_5,
                    BSVAC_6,
                    BSVAC_7
                )
                AgencyModel.GVEMS -> listOf(
                    GVEMS_7,
                    GVEMS_8,
                    GVEMS_9
                )
                null -> emptyList()
            }
        }
    }

}
